import { gql } from "@apollo/client";

const listCampaigns = gql`
  query ListCampaigns {
    listCampaigns {
      id
      title
      titleShort
    }
  }
`;

export default listCampaigns;
